import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { MembershipCloudUser } from 'src/features/membership/types';
import DeleteMembershipCloudUser from 'src/features/membershipCloudUsers/components/forms/DeleteMembershipCloudUser';
import { membershipUsersMessages } from 'src/features/membershipCloudUsers/utils/messages';
import UpdateMembershipCloudUserFormModal from 'src/features/membershipCloudUsers/components/forms/UpdateMembershipCloudUserFormModal';

interface CellMembershipCloudUserActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    membershipId: string;
}

export default function CellMembershipCloudUserActions({
    row,
    membershipId,
}: CellMembershipCloudUserActionsProps<MembershipCloudUser, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateMembershipCloudUserFormModal
                        selectedCloudUser={row.original}
                        membershipId={membershipId}
                        semantics={{
                            entryName: formatMessage(membershipUsersMessages.membershipUser).toLowerCase(),
                        }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateMembershipCloudUserFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>

                <Tooltip>
                    <DeleteMembershipCloudUser
                        selectedUser={row.original}
                        membershipId={membershipId}
                        semantics={{
                            entryName: formatMessage(membershipUsersMessages.membershipUser).toLowerCase(),
                        }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteMembershipCloudUser>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
